import { render } from "./RetirementDetail.vue?vue&type=template&id=f5c44044"
import script from "./RetirementDetail.vue?vue&type=script&lang=js"
export * from "./RetirementDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__